<div class="portal-card">
  <div class="portal-card-body">
    <a class="portal-card-title"
      [routerLink]="['search', 'thematic-tag', categorySlug]"
      (click)="gaService.emitPortalCardClick(categorySlug)">
      <span>{{ title }}</span>
      <svg aria-hidden="true" class="portal-card-title-icon" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0C5.376.008.008 5.376 0 12zm13.707-5.209l4.5 4.5a1 1 0 010 1.414l-4.5 4.5a1 1 0 01-1.414-1.414l2.366-2.367a.25.25 0 00-.177-.424H6a1 1 0 010-2h8.482a.25.25 0 00.177-.427l-2.366-2.368a1 1 0 011.414-1.414z" fill="#3B6FB6" fill-rule="nonzero"></path>
      </svg>
    </a>
    @if (entriesCount !== entriesCountPlaceholder) {
      <p class="portal-card-entries">{{ entriesCount }} entries</p>
    } @else {
      <!-- Same small spinner already used in the foldseek-table tabs (e.g. afdb-tab's
           "Download in progress" indicator) — kept inside the same .portal-card-entries
           wrapper, at the same height, so the card's layout doesn't shift once the real
           count arrives (AFPDBE-1418). -->
      <p class="portal-card-entries portal-card-entries-loading" aria-label="Loading entry count">
        <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="portal-card-entries-spinner" stroke="#707372" fill="#707372" />
        </svg>
      </p>
    }
    <p class="portal-card-description">{{ description }}</p>
  </div>
  <div class="portal-card-bar" [style.background-color]="accentColor"></div>
</div>
